module.exports = __webpack_public_path__ + "img/imagen_covid.66ecb82e.jpg";